import { ProgramsBillingType } from '../models';

export * from '../models';
export { Actions, Effect, ofType } from '@ngrx/effects';
export { select, Store, Action } from '@ngrx/store';

export enum AppFields {
  App = 'app',
  Club = 'club',
  User = 'user',
  Staff = 'staff',
  ClubStaff = 'club-staff',
  Program = 'proram',
  TransactionDetails = 'transaction-details',
  TeamAccount = 'team-account',
  BillingTypeID = 'billing-type-id',
  OrgId = 'org-id',
  TryoutUserProgramRole = 'tryout-user-program-role',
  Players = 'club-players',
  PlayersList = 'club-players-list',
  TeamSubscriptionPlans = 'team-subscription-plans',
  ClubSubscriptionPlans = 'club-subscription-plans',
  SubscriptionPlans = 'subscription-plans',
  TeamPlayers = 'team-players',
  StaffEvaluations = 'staff-evalautions',
  ClubProgramFees = 'club-program-fees',
  PageTitle = 'page-title',
  PageSmallTitle = 'page-small-title',
  PlayerFormTypes = 'player-form-types',
  EvalautionAccount = 'evaluation-account',
  MyTeam = 'my-team',
  TeamEventMatch = 'team-event-match',
  TeamEvent = 'team-event',
  ClubEvent = 'club-event',
  CollegeMatchEvent = 'college-match-event',
  MessageCounts = 'message-counts',
  AllStates = 'all-states',
  AllCountries = 'all-countries',
  UserRoles = 'user-roles',
  ClubOverallScore = 'club-overall-score',
  ClubTeamsStat = 'club-teams-stat',
  ClubProductUsage = 'club-product-usage',
  ClubComplexVenues = 'club-complex-venues',
  PlayerPositions = 'player-positions',
  TeamsList = 'teams-list',
  CollegeRecruitingPlayer = 'college-recruiting-player',
  IndividualGameSurvayData = 'individual-game-survery-data',
  SchedulesLeftNavCount = 'get-team-schedules-leftnav-count',
  GetCollegeLeftNavCounts = 'get-college-dashboard-left-nav-counts',
  GetCollegeDetails = 'get-college-data-by-ID',
  GetPlayerAttendingThisCollegeData = 'get-player-college-attending-data',
  GetTeamPlayerList = 'get-team-player-list',
  SelectedOrgSeason = 'selected-org-season'
}

export interface AppState {
  [field: string]: any;
}

export const InitialState: AppState = {
  [AppFields.Club]: null,
  [AppFields.Program]: null,
  [AppFields.User]: null,
  [AppFields.TransactionDetails]: null,
  [AppFields.TeamAccount]: null,
  [AppFields.BillingTypeID]: ProgramsBillingType.ClubBilling,
  [AppFields.OrgId]: null,
  [AppFields.TryoutUserProgramRole]: null,
  [AppFields.Players]: null,
  [AppFields.PlayersList]: null,
  [AppFields.ClubProgramFees]: null,
  [AppFields.SubscriptionPlans]: null,
  [AppFields.TeamPlayers]: null,
  [AppFields.StaffEvaluations]: null,
  [AppFields.PageTitle]: null,
  [AppFields.PageSmallTitle]: null,
  [AppFields.PlayerFormTypes]: null,
  [AppFields.EvalautionAccount]: null,
  [AppFields.MyTeam]: null,
  [AppFields.TeamEventMatch]: null,
  [AppFields.TeamEvent]: null,
  [AppFields.ClubEvent]: null,
  [AppFields.CollegeMatchEvent]: null,
  [AppFields.MessageCounts]: null,
  [AppFields.AllStates]: null,
  [AppFields.AllCountries]: null,
  [AppFields.UserRoles]: null,
  [AppFields.ClubOverallScore]: null,
  [AppFields.ClubTeamsStat]: null,
  [AppFields.ClubProductUsage]: null,
  [AppFields.ClubComplexVenues]: null,
  [AppFields.PlayerPositions]: null,
  [AppFields.Staff]: null,
  [AppFields.ClubStaff]: null,
  [AppFields.TeamsList]: null,
  [AppFields.CollegeRecruitingPlayer]: null,
  [AppFields.IndividualGameSurvayData]: null,
  [AppFields.SchedulesLeftNavCount]: null,
  [AppFields.GetCollegeLeftNavCounts]: null,
  [AppFields.GetCollegeDetails]: null,
  [AppFields.GetPlayerAttendingThisCollegeData]: null,
  [AppFields.GetTeamPlayerList]: null,
  [AppFields.SelectedOrgSeason]: null
};

export enum AppTypes {
  UpdateState = 'update-app-state',
  InitializeClub = 'initialize-club',
  InitializeProgram = 'initialize-program',
  InitializeUser = 'initialize-user',
  GetTransactionDetails = 'get-transaction-details',
  ValidateUser = 'validate-user',
  GetClubPlayers = 'get-club-players',
  GetClubPlayersList = 'get-club-players-list',
  GetClubTeamPlayers = 'get-club-team-players',
  GetClubCollegeRecruiting = 'get-club-college-recruiting',
  GetTeamPlayers = 'get-team-players',
  GetStaffEvaluations = 'get-staff-evaluations',
  GetClubProgramFees = 'get-program-fees',
  GetPlayerFormTypes = 'get-player-form-types',
  GetAllStates = 'get-all-states',
  GetAllCountries = 'get-all-countries',
  GetUserRoles = 'get-team-user-roles',
  GetClubOverallScore = 'get-club-overall-score',
  GetClubTeamsStat = 'get-club-teams-stat',
  GetClubProductUsage = 'get-club-product-usage',
  GetClubComplexVenues = 'get-club-complex-venues',
  GetPlayerPositions = 'get-player-positions',
  GetTeamsList = 'get-teams-list',
  GetStaffList = 'get-staff-list',
  GetSchedulesLeftNavCount = 'get-team-schedules-leftnav-count',
  GetCollegeLeftNavCounts = 'get-college-dashboard-left-nav-counts',
  GetCollegeDetails = 'get-college-data-by-ID',
  GetPlayerAttendingThisCollegeData = 'get-player-college-attending-data',
  GetSubscriptionPlans = 'get-subscription-plans',
  GetTeamPlayerList = 'get-team-player-list',
}

export interface UpdateState {
  type: AppTypes.UpdateState;
  payload: any;
}

export interface InitializeClub {
  type: AppTypes.InitializeClub;
  payload: { clubId: number };
}

export interface InitializeProgram {
  type: AppTypes.InitializeProgram;
  payload: { programId: number };
}

export interface InitializeUser {
  type: AppTypes.InitializeUser;
  payload: { userId: number };
}

export interface GetTransactionDetails {
  type: AppTypes.GetTransactionDetails;
  payload: { programId: number };
}

export interface ValidateUser {
  type: AppTypes.ValidateUser;
  payload: {
    clubId: number;
    teamId: number;
    tokenValue: string;
    redirect: string;
  };
}

export interface GetClubPlayers {
  type: AppTypes.GetClubPlayers;
  payload: { clubId: number; teamId: number; paymentStatus: boolean; };
}

export interface GetClubPlayersList {
  type: AppTypes.GetClubPlayersList;
  payload: { clubId: number; teamId: number; };
}

export interface GetClubCollegeRecruiting {
  type: AppTypes.GetClubCollegeRecruiting;
  payload: { clubId: number };
}

export interface GetTeamPlayers {
  type: AppTypes.GetTeamPlayers;
  payload: { clubId: number; teamId: number; programId: number };
}

export interface GetStaffEvaluations {
  type: AppTypes.GetStaffEvaluations;
  payload: { userId: number };
}

export interface GetStaffEvaluations {
  type: AppTypes.GetStaffEvaluations;
  payload: { userId: number };
}

export interface GetClubProgramFees {
  type: AppTypes.GetClubPlayers;
  payload: { clubId: number; teamId: number };
}

export interface GetClubTeamPlayers {
  type: AppTypes.GetClubTeamPlayers;
  payload: { clubId: number; teamId: number };
}

export interface GetPlayerFormTypes {
  type: AppTypes.GetClubPlayers;
}

export interface GetAllCountries {
  type: AppTypes.GetAllCountries;
}

export interface GetAllStates {
  type: AppTypes.GetAllStates;
}

export interface GetUserRoles {
  type: AppTypes.GetUserRoles;
}

export interface GetClubOverallScore {
  type: AppTypes.GetClubOverallScore;
  payload: {
    clubID: number;
  };
}

export interface GetClubProductUsage {
  type: AppTypes.GetClubProductUsage;
  payload: {
    clubID: number;
  };
}

export interface GetClubTeamsStat {
  type: AppTypes.GetClubTeamsStat;
  payload: {
    clubID: number;
  };
}

export interface GetPlayerPositions {
  type: AppTypes.GetPlayerPositions;
  payload: {
    clubID: number;
  };
}

export interface GetStaffList { type: AppTypes.GetStaffList; payload: { clubID: number, status: number }; }
export interface GetTeamsList { type: AppTypes.GetTeamsList; }

export interface GetSubscriptionPlans {
  type: AppTypes.GetSubscriptionPlans;
  payload: {
    clubID: number,
    teamID: number
  };
}
export interface GetTeamPlayerList {
  type: AppTypes.GetTeamPlayerList;
  payload: {
    teamID: number
  };
}

export interface GetSchedulesLeftNavCount {
  type: AppTypes.GetSchedulesLeftNavCount;
  payload: {
    teamID: number,
    userID: number
  };
}

export interface GetCollegeLeftNavCounts {
  type: AppTypes.GetCollegeLeftNavCounts;
  payload: {
    clubID: number,
    collegeID: number,
    collegeProgramID: number,
    teamID: number
  };
}

export interface GetCollegeDetails {
  type: AppTypes.GetCollegeDetails;
  payload: {
    collegeID: number,
    collegeProgramID: number
  };
}

export interface GetPlayerAttendingThisCollegeData {
  type: AppTypes.GetPlayerAttendingThisCollegeData;
  payload: {
    clubID: number,
    collegeID: number,
    teamID:number
  };
}
export type AppAction =
  | UpdateState
  | InitializeClub
  | InitializeProgram
  | InitializeUser
  | ValidateUser;



// WEBPACK FOOTER //
// ./src/app/store/app.models.ts